import Home from '../components/Home'

let routes = {
    path: '/dashboard',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/dashboard',
            name: 'Home',
            component: Home
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/home.js